import React from "react";
import { useThemedLogo } from "components/hooks/useThemedLogo";

interface AuthHeaderProps {
  title: string;
  message?: string;
  icon?: React.ReactNode;
}

export const AuthHeader: React.FC<AuthHeaderProps> = ({
  title,
  message,
  icon,
}) => {
  const Logo = useThemedLogo();
  return (
    <div className="sm:mx-auto sm:w-full sm:max-w-sm">
      <div className="mt-10 items-center text-center">
        {icon || <Logo className="w-18 h-18 mx-auto" aria-label="Logo" />}
      </div>
      <h2 className="mt-2 tracking-tight text-center text-fg-title">{title}</h2>
      {message && <p className="text-center text-success">{message}</p>}
    </div>
  );
};
